/**
 * @file index.tsx
 *
 * @fileoverview Component for featured jobs.
 */
import React from 'react';
import { FeaturedJobsParagraph, Job } from '~/jobiqo/types/types';
import { JobTeasersGrid } from '~/jobiqo/components/Landingpage/JobsTeasersGrid';

interface LandingPageJobsProps {
  /**
   * Top intro text for display on the landing page row.
   */
  rowFeaturedJobsInfo: FeaturedJobsParagraph;
  /**
   * The size for the container.
   */
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
}

export const LandingPageJobs = ({
  rowFeaturedJobsInfo,
  maxContainerSize,
}: LandingPageJobsProps) => {
  if (rowFeaturedJobsInfo?.jobdata?.pages?.length === 0) {
    // Do not show the row if there are no jobs.
    return null;
  }

  return (
    <JobTeasersGrid
      jobs={(rowFeaturedJobsInfo?.jobdata?.pages as [Job]) ?? []}
      paragraphInfo={rowFeaturedJobsInfo}
      maxContainerSize={maxContainerSize}
    />
  );
};
export default LandingPageJobs;
